/**
 * Delays the execution for a specified duration.
 *
 * @param {number} [duration=1000] - The duration to delay in milliseconds. Defaults to 1000ms.
 * @returns {Promise<void>} A promise that resolves after the specified duration.
 *
 * @example
 * // Delay for 1 second
 * await delay(1000);
 *
 * @example
 * // Delay for the default duration (1 second)
 * await delay();
 */
export const delay = async (duration: number = 1_000): Promise<void> =>
  await new Promise((resolve) => setTimeout(resolve, duration));
